import { axiosBase } from "./axiosBase";
const TOTAL_PRODUCT_COUNT = "product/totalcount";
const TOTAL_PRODUCT_CLICK = "product/totalclick";
const BASE = "product";
const BULK_DELETE = "product/deletebulk";

export const productService = {
  getTotalCount: () => {
    return axiosBase.get(TOTAL_PRODUCT_COUNT);
  },
  getTotalClick: () => {
    return axiosBase.get(TOTAL_PRODUCT_CLICK);
  },
  getAll: () => {
    return axiosBase.get(BASE);
  },
  add: (values: any) => {
    return axiosBase.post(BASE, values);
  },
  deleteBulk: (deletedIds: []) => {
    const dObj = { Ids: deletedIds };
    return axiosBase.post(BULK_DELETE, dObj);
  },
  update: (product: any) => {
    return axiosBase.put(`${BASE}/${product.id}`, product);
  },
  pData : () => {
    return axiosBase.get(`${BASE}/product-data`)
  }
};
